import { render, staticRenderFns } from "./Dwhc.vue?vue&type=template&id=5fc85519&scoped=true&"
import script from "./Dwhc.vue?vue&type=script&lang=js&"
export * from "./Dwhc.vue?vue&type=script&lang=js&"
import style0 from "./Dwhc.vue?vue&type=style&index=0&id=5fc85519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85519",
  null
  
)

export default component.exports